import Drawer from '@mozaic-ds/freemarker/js/modules/_drawer.js';
import { addEvent } from '../includes/_events';
export const initDrawers = self => {
  if (!self._drawers) {
    self._drawers = {};
  }
  addEvent(document, 'click', el => {
    const drawerId = el.matchingTarget.dataset.drawerId;
    if (!drawerId) {
      console.error('Missing drawer id', el.matchingTarget);
      return;
    }
    if (!self._drawers[drawerId]) {
      self._drawers[drawerId] = new Drawer({
        classContent: drawerId
      });
    }
    self._drawers[drawerId].open();
  }, '.js-generic-drawer', self);
};